/**
 * Web implementation for Firebase Crashlytics
 * This provides a mock implementation that completely disables crashlytics on web
 */

const log = (_message: string) => {
  // No-op implementation
  return Promise.resolve();
};

const recordError = (_error: Error) => {
  // No-op implementation
  return Promise.resolve();
};

const setAttribute = (_name: string, _value: string) => {
  // No-op implementation
  return Promise.resolve();
};

const setUserId = (_userId: string) => {
  // No-op implementation
  return Promise.resolve();
};

const setAttributes = (_attributes: Record<string, string>) => {
  // No-op implementation
  return Promise.resolve();
};

const setCrashlyticsCollectionEnabled = (_enabled: boolean) => {
  // No-op implementation
  return Promise.resolve();
};

// Remove error handlers since we're not using Firebase
if (typeof window !== 'undefined') {
  window.addEventListener('error', _event => {
    // No-op implementation
  });

  window.addEventListener('unhandledrejection', _event => {
    // No-op implementation
  });
}

export default {
  log,
  recordError,
  setAttribute,
  setAttributes,
  setUserId,
  setCrashlyticsCollectionEnabled,
}; 